<template lang="pug">
  div(class="billing-overview__card")
    div(class="billing-overview__card-top")
      h4(class="text-16px dark fw-500 pb-1") {{ $t('Additional documents') }}
      div(class="text-12px fw-300 pb-6") {{ $t('Need more documents? Buy more for lower price') }}
      v-slider(
        v-model="documentCountIdx"
        class="documents-slider"
        step="1"
        :max="sliderOptions.length - 1"
        tick-size="12"
        :tick-labels="sliderOptions"
        ticks="always"
        track-color="#F1F1F1"
        thumb-size="24"
      )
    div(class="billing-overview__card-bottom")
      billing-payment-info(
        :info="buyDocumentsInfo"
        gray
        class="mt-6"
      )
      div(class="billing-overview__actions")
        v-btn(
          outlined
          :loading="purchaseLoading"
          @click="purchase('document', sliderOptions[documentCountIdx])"
        ) {{ $t('Go to payment') }}
</template>

<script>
import { mapGetters } from 'vuex'
import BillingPaymentInfo from '~/modules/billing/components/billing-payment-info'
import currencyFormat from '~/mixins/filters/currencyFormat'
import actions from '~/modules/billing/mixins/actions'

export default {
  name: 'BillingDocumentsCard',
  components: {
    BillingPaymentInfo
  },
  mixins: [currencyFormat, actions],
  data() {
    return {
      documentCountIdx: null,
      sliderOptions: [10, 50, 100, 250, 300, 500, 750, 1000, 5000, 10000]
    }
  },
  computed: {
    ...mapGetters('billing', {
      currentPlan: 'currentPlan',
      additionalDocuments: 'additionalDocuments'
    }),
    documentsCountString() {
      return `${this.sliderOptions[this.documentCountIdx]} док.`
    },
    pricePerDocument() {
      return this._.get(this.currentPlan, 'tariff.documentPrice')
    },
    pricePerDocumentString() {
      const documentPrice = this.pricePerDocument / 100
      return this.handleUahString(documentPrice)
    },
    documentsSummaryString() {
      const summary = (this.pricePerDocument / 100) * this.sliderOptions[this.documentCountIdx]
      return this.handleUahString(summary)
    },
    buyDocumentsInfo() {
      return {
        firstRow: {
          label: this.$t('Count'),
          value: this.documentsCountString
        },
        secondRow: {
          label: this.$t('Price per document'),
          value: this.pricePerDocumentString
        },
        summaryRow: {
          label: `${this.$t('To be paid')}:`,
          value: this.documentsSummaryString
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.documents-slider {
  &::v-deep {
    .v-slider__tick {
      width: 12px !important;
      height: 12px !important;
      border-radius: 50%;
      background-color: #f1f1f1 !important;
      transform: scale(0.8);
    }

    .v-slider__tick-label {
      text-align: center;
      padding-top: 20px !important;

      font-size: 14px !important;
    }

    .v-slider__tick--filled {
      background: $primary !important;
    }

    .v-slider__track-container {
      height: 6px !important;
    }

    .v-slider__thumb {
      width: 16px !important;
      height: 16px !important;

      &:before {
        top: -10px !important;
        left: -10px !important;
      }
    }
  }
}
</style>
